import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { MenuModule, Permission, SubMenu } from '@/constant/permissions';

interface MenuGrant {
  module: string;
  subModule?: string[];
}

export interface UserPermissions {
  // false until the login response has filled the store
  userPermissionsLoaded: boolean;
  userCan: (permission: Permission) => boolean;
  userCanAny: (permissions: Permission[]) => boolean;
  userCanAll: (permissions: Permission[]) => boolean;
  userHasMenu: (module: MenuModule, subModule?: SubMenu) => boolean;
}

// The signed-in user's permissions. The Set is built once per login payload, so every check after that is a lookup.
export const usePermissions = (): UserPermissions => {
  const codes: string[] | undefined = useSelector((state: any) => state.auth.permission?.permissions?.[0]);
  const menu: MenuGrant[] | undefined = useSelector((state: any) => state.auth.permission?.menu);

  return useMemo(() => {
    const granted = new Set(codes ?? []);
    const userCan = (permission: Permission) => granted.has(permission);
    return {
      userPermissionsLoaded: granted.size > 0,
      userCan,
      userCanAny: (permissions: Permission[]) => permissions.some(userCan),
      userCanAll: (permissions: Permission[]) => permissions.every(userCan),
      userHasMenu: (module: MenuModule, subModule?: SubMenu) => Boolean(menu?.some((grant) => (
        grant.module === module && (!subModule || grant.subModule?.includes(subModule))
      ))),
    };
  }, [ codes, menu ]);
};
